import { fetchWrapper } from "../../app/sagas/fetchSagaFactory";

import { EnumGroup, isEnumGroupArray } from "./types";
import { EMPTY_CLIENT_TRANSPORT } from "./const";

export async function loadContactData(appKey: string[], docRef: string): Promise<EnumGroup[]> {
	const params = appKey.map(key => `params=${encodeURIComponent(key)}`).join("&");
	const response = await fetchWrapper({
		relativeUrl: `/enumerations?src=CONTACTS&${params}&docRef=${docRef}`,
		method: "GET"
	});
	if (!response.ok) {
		return Promise.reject("Fehler beim Laden der Kontaktdaten");
	}

	const data = await response.json();
	if (!isEnumGroupArray(data)) {
		return Promise.reject("Ungültige Datenstruktur für Kontaktdaten");
	}
	return data;
}

/**
 * Loads contact data for the given appKeys filtered to the given clients, without requiring a
 * document reference. An empty string in {@code clients} matches records with no client set.
 * An empty array applies no client filter (returns all).
 */
export async function loadContactDataByClients(appKeys: string[], clients: string[]): Promise<EnumGroup[]> {
	const params = appKeys.map(key => `params=${encodeURIComponent(key)}`).join("&");
	// Empty string is a valid client value but cannot be reliably transported as an empty query
	// param. Substitute the transport constant so the value survives HTTP serialisation.
	const transportClients = clients.map(c => (c === "" ? EMPTY_CLIENT_TRANSPORT : c));
	const clientParams = transportClients.map(c => `clients=${encodeURIComponent(c)}`).join("&");
	const query = clientParams ? `${params}&${clientParams}` : params;
	const response = await fetchWrapper({
		relativeUrl: `/enumerations?src=CONTACTS&${query}`,
		method: "GET"
	});
	if (!response.ok) {
		return Promise.reject("Fehler beim Laden der Kontaktdaten");
	}
	const data = await response.json();
	if (!isEnumGroupArray(data)) {
		return Promise.reject("Ungültige Datenstruktur für Kontaktdaten");
	}
	return data;
}
